import { Component, OnInit } from '@angular/core';
import { Loader } from "@googlemaps/js-api-loader"
import { Subscription } from 'rxjs';
import { FirebaseService } from 'src/app/core/services/firebase.service';
import { BrdsqlService } from 'src/app/core/services/brdsql.service';
import { environment } from 'src/environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { map } from 'rxjs/operators';
import * as LZString from 'lz-string';

@Component({
  selector: 'app-cp-map',
  templateUrl: './cp-map.component.html',
  styleUrls: ['./cp-map.component.css']
})
export class CpMapComponent implements OnInit {

  private map: google.maps.Map;
  private currentPolygon: google.maps.Polygon | null = null;
  private userRadius: google.maps.Circle | null = null;

  loader = new Loader({
    apiKey: environment.firebase.mapkey,
    libraries: ["places", "marker"],
    version: 'weekly',
  });
  upos = { lat: 15.228581111646495, lng: 103.07182686761979 };
  mapsInfoWindow: google.maps.InfoWindow | null = null;
  circle: google.maps.Circle | null = null;
  radius?: any | number = 40000
  mapFb?: any = [];
  cpSql?: any = [];
  mapFbFm?: any = [];
  cpFmdata?: any = [];
  cpDetail?: any = [];
  yearCr = '2425'
  fmcode = '0000149888'
  supzone = '06.1'
  public allmap?: any = []
  cntAllPlot = 0
  cntFilterPlot = 0
  areaFilterPlot = 0
  canevalueFilterPlot = 0
  isHidden = false;

  constructor(
    private fbservice: FirebaseService,
    private brdsql: BrdsqlService,
    private spinner: NgxSpinnerService,
  ) {
    this.getMapFb()
  }

  ngOnInit(): void {
  }

  ckData() {
    let fbData = localStorage.getItem('mapFb')
  }

  // แผนที่แปลงอ้อยทั้งหมดของปีจาก firebase
  async getMapFb() {
    let ckMapdata = localStorage.getItem('testcompress')
    if (!ckMapdata) {
      console.log('!not found testcompress...')
      this.spinner.show()
      localStorage.removeItem('mapFb')
      await this.fbservice.getmapAll(this.yearCr)
        .then((res: any) => {
          // console.log('firebase res:', res)
          if (res) {
            this.cntAllPlot = res.length
            this.allmap = res
          }
        })
        .catch((err) => { console.error(err) })
        .finally(() => {
          this.loadAllcpYear();
        })
    } else {
      // 
      console.log('found testcompress...')
      this.loadFromLocalStorage('testcompress');
    }

  }

  // โหลดข้อมูลแปลงอ้อยทั้งหมดของปีจาก sql
  async loadAllcpYear() {
    await this.brdsql.getCpAll(this.yearCr).subscribe({
      next: (res: any) => {
        if(res) {
          // console.log('cpsql res: ' ,res)
          this.cpSql = res.recordset;
          // console.log('cpsql : ' ,this.cpSql)
        }
      },error(err) {
        
      },complete:() => {
        this.loadAndMergeData();
        this.spinner.hide();
      },
    })
  }

  // รวมข้อมูลระหว่าง Firebase และ sql
  loadAndMergeData() {

    // type dataFb = { key: string, coordinates: string, coordinatesCenter: string ,canetype: string, landvalue?: number, fmname: string, groupcode: string };
    // type dataSql = { itid: string, canetype: string, landvalue?: number, fmname: string, groupcode: string  };
    // let mapfb: dataFb[] = [];
    // let cpdata: dataSql[] = [] 

    let data1 = this.allmap
    let data2 = this.cpSql;
    let ftdata = []
    for (let i = 0; i < data1.length; i++) {
      ftdata.push({
        "key": data1[i].key,
        "landno": data1[i].landno,
        "coordinates": data1[i].coordinates,
        "coordinatesCenter": data1[i].coordinatesCenter,
        "canetype": "",
        "landvalue": 0,
        "seedcode": "",
        "fmname": "",
        "groupcode": "",
        "supzone": "",
        "supcode": "",
        "partcode": "",
        "gradenow": "",
        "ton": 0,
        "assess": 0,
        "cutstatus": "",
        "arealevel": "",
      });
    }

    ftdata.forEach(user => {
      const match = data2.find(data => data.itid === user.key);
      if (match) {
        user.canetype = match.canetype;
        user.landvalue = match.landvalue;
        user.fmname = match.fmname;
        user.groupcode = match.groupcode;
        user.supcode = match.supcode;
        user.supzone = match.supzone;
        user.partcode = match.partcode;
        user.gradenow = match.gradenow;
        user.ton = match.ton;
        user.assess = match.assess;
        user.seedcode = match.seedcode;
        user.arealevel = match.arealevel;
        user.cutstatus = match.cutstatus;

      }
    });
    // console.log('data merge :', ftdata)
    this.allmap = ftdata
    this.testX(ftdata)
  }  

  // โหลดข้อมูลแปลงอ้อยของชาวไร่จาก api
  subMapFmdata!: Subscription;
  async getCpFmdata(fmcode: string) {
    localStorage.removeItem('cpfmdata')
    this.subMapFmdata = await this.brdsql.getCpFm(this.yearCr, fmcode).subscribe({
      next: (res: any) => {
        console.log('cp fm res ', res)
        this.cpFmdata = res.recordset
        // console.log('coordinatescenter[0] :' ,res.recordset[0].coordinatescenter)
        // localStorage.setItem('cpfmdata', JSON.stringify(this.cpFmdata))

        let jsonString = res.recordset[0].coordinates;
        console.log('jsonString :', jsonString)
        const jsonObject = eval('(' + jsonString + ')');
        console.log('jsonObject :', jsonObject);

        //let jsonArray = JSON.parse(jsonString);
        //console.log('jsonArray :' ,jsonArray); // This will output the array of objects

        // this.closeLoading()
      }, error(err) {
        alert('Error :' + err)
      }, complete: () => {
        this.loadMap();
      },
    })
  }

  // แสดงแผนที่แปลงอ้อย
  loadMap() {
    // coordinates จาก sql
    let mapfb = this.cpFmdata
    console.log('mapfb is: ', mapfb)
    console.log('coordinatescenter[0] is: ', mapfb[0].coordinatescenter)
    // let cpfm = this.cpFmdata
    let upos = this.upos

    if (mapfb.length == 0) {
      // this.presentToast('middle', '!!ไม่พบข้อมูล แผนที่แปลงอ้อยในปีที่เลือก..', 'warning')
      this.loader.load().then(() => {

        this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
          center: this.upos,
          zoom: 16,
          mapTypeId: 'roadmap',
        })

        // 2. Create marker
        let label: string = "<i class='fas fa-map-pin'></i> <span class='ggSriracha'> คุณอยู่ที่นี่ </span>"
        const marker = new google.maps.marker.AdvancedMarkerElement({
          position: upos,
          map: this.map,
          title: 'คุณอยู่ที่นี่',
          content: document.createElement('div'),
        });
        
        // Set custom icon for AdvancedMarkerElement
        const iconElement = document.createElement('img');
        iconElement.src = 'assets/icon/fm64.png';
        iconElement.style.width = '32px';
        iconElement.style.height = '32px';
        marker.content = iconElement;
      });
    } else {
      this.loader.load().then(() => {

        let dataCenter = mapfb[0].coordinatescenter;
        let jsonCenter = JSON.parse(dataCenter);
        console.log('jsonCenter :', jsonCenter); // This will output the array of objects
        upos = jsonCenter

        // for (let i = 0; i < mapfb.length; i++) { }
        // 1. create map
        this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
          center: upos,
          zoom: 16,
          mapTypeId: 'roadmap',
        })

        const icon = {
          url: 'assets/images/bsflogo.png', // URL to the icon image
          scaledSize: new google.maps.Size(50, 50), // size in pixels
          origin: new google.maps.Point(0, 0), // origin of the image
          anchor: new google.maps.Point(25, 25) // anchor point of the image
        };

        // 2. Create marker
        // let label: string = "<i class='fas fa-map-pin'></i> <span class='ggSriracha'> คุณอยู่ที่นี่ </span>"
        // const marker = new google.maps.Marker({
        //   position: this.upos,
        //   map,
        //   label: "",
        //   icon: icon,
        //   // animation: google.maps.Animation.BOUNCE,
        // });

        // 3. Create circle
        const circle = new google.maps.Circle({
          center: upos,
          map: this.map,
          strokeWeight: 2,
          strokeColor: '#FF992C',
          fillColor: '#F5F8B4',
          fillOpacity: 0.35,
          radius: this.radius,  // รัศมีเป็นเมตร
        })

        // create marker polygon infowindows
        for (let i = 0; i < mapfb.length; i++) {

          // const marker = new google.maps.Marker({
          //   position: { lat: mapfb[i].coordinatesCenter.lat, lng: mapfb[i].coordinatesCenter.lng },
          //   map,
          // });
          // marker.addListener('click', () => {
          //   alert('click on marker')
          //   // this.presentActionSheet(mapfb[i].key)
          //   // infowindow.open({
          //   //   anchor: marker,
          //   //   map,
          //   //   shouldFocus: false,
          //   // });
          // });

          // 4. Create InfoWindow.
          // let label: string = "<i class='fas fa-map-pin'></i> <span class='ggSriracha'>"+ mapfb[i].bnm_profile.name +"</span>"
          // let infoWindow = new google.maps.InfoWindow({
          //   content: label,
          //   position:  { lat: mapfb[i].coordinatesCenter.lat, lng: mapfb[i].coordinatesCenter.lng },
          // });
          // infoWindow.open(map);          

          // 5. create polygon
          // let fillColor = "#6A6A6A"
          // let canetype = mapfb[i].canetype
          // canetype = canetype.substring(1,2)
          // if (canetype !== undefined) {
          //   if (canetype == 'R') {
          //     fillColor = "#09FD0C"
          //   } else if (canetype == 'T') {
          //     fillColor = "#E9FD09"
          //   } else {
          //     fillColor = "#6A6A6A"
          //   }
          // }

          // แปลง text เป็น json object 
          //   const jsonString: string = mapfb[0].coordinates;
          // const jsonObject = new Function('return ' + jsonString)();
          // console.log('jsonObject:' ,jsonObject);  

          //   let jsonString = mapfb[0].coordinates;
          // console.log('mapfb[0].coordinates :' ,jsonString)
          // const jsonObject = eval('(' + jsonString + ')');
          // console.log('jsonObject :' ,jsonObject);

          // let dataPolygon = mapfb[0].coordinates;
          // let jsonPolygon = JSON.parse(dataPolygon);
          // console.log('jsonPolygon :' ,jsonPolygon); // This will output the array of objects

          // const triangleCoords = jsonPolygon;
          // console.log('triangleCoords is:' ,triangleCoords)
          // const bermudaTriangle = new google.maps.Polygon({
          //   paths: triangleCoords,
          //   strokeColor: '#FF5C3F',
          //   strokeOpacity: 0.8,
          //   strokeWeight: 2,
          //   fillColor: fillColor,
          //   fillOpacity: 0.35,
          // });
          // bermudaTriangle.setMap(map);

          // bermudaTriangle.addListener('click' , () => {

          // if (this.mapsInfoWindow) {
          //     this.mapsInfoWindow.close();
          // }

          // let contentString = `
          // <div class="card bg-light d-flex flex-fill">
          //   <div class="card-header text-muted border-bottom-0">
          //     แปลง : ${mapfb[i].intlandno}
          //   </div>
          //   <div class="card-body pt-0">
          //     <div class="row">
          //       <div class="col-7">
          //         <h2 class="lead"><b>${mapfb[i].fmname}</b></h2>
          //         <!-- <h2 class="lead"><b>XXX</b></h2> -->
          //         <p class="text-muted text-sm"><b>พื้นที่ : </b> ${mapfb[i].landvalue} </p>
          //         <p class="text-muted text-sm"><b>ประเภท : </b> ${mapfb[i].canetype} </p>
          //         <ul class="ml-4 mb-0 fa-ul text-muted">
          //           <li class="small"><span class="fa-li"><i class="fas fa-lg fa-building"></i></span> Address: Demo Street 123, Demo City 04312, NJ</li>
          //           <li class="small"><span class="fa-li"><i class="fas fa-lg fa-phone"></i></span> Phone #: + 800 - 12 12 23 52</li>
          //         </ul>
          //       </div>
          //       <div class="col-5 text-center">
          //         <img src="assets/images/bsfLogo.png" alt="fmbrr" class="img-circle img-fluid">
          //       </div>
          //     </div>
          //   </div>
          //   <div class="card-footer">
          //     <div class="text-right">
          //       <a href="#" class="btn btn-sm bg-teal">
          //         <i class="fas fa-comments"></i>
          //       </a>
          //       <a href="#" class="btn btn-sm btn-primary">
          //         <i class="fas fa-user"></i> View Profile
          //       </a>
          //     </div>
          //   </div>
          // </div>
          // `;

          // this.mapsInfoWindow = new google.maps.InfoWindow({
          //   content: contentString,
          //   position:  { lat: mapfb[i].coordinatescenter.lat, lng: mapfb[i].coordinatescenter.lng },
          //   maxWidth: 400,
          // })

          // this.mapsInfoWindow.open(map);

          // alert('แปลงของ '+ mapfb[i].bnm_profile.name)
          // this.getDetailPlot(mapfb[i].itid)

          // const marker = new google.maps.Marker({
          //   position: { lat: mapfb[i].coordinatesCenter.lat, lng: mapfb[i].coordinatesCenter.lng },
          //   map: map,
          //   title: mapfb[i].bnm_profile.name,
          // });

          // const infoWindow = new google.maps.InfoWindow({
          //   content: contentString,
          //   position: { lat: mapfb[i].coordinatesCenter.lat, lng: mapfb[i].coordinatesCenter.lng },
          //   maxWidth: 1024,
          // }); 

          // infoWindow.open(map);

          // })

        }
        //+++++++ End for +++++++++++++++++

      });
    }
  }

  setCircle(e: any) {
    console.log('event ', e)
    console.log('value ', e.target.value)
    this.radius = Number(e.target.value)
    setTimeout(() => {
      this.loadMap1()
    }, 500);
  }

  async setMapZone(e: any) {
    console.log('select zone :', e.target.value)
    // this.loadMapZone(e.target.value)
    let mapfb = this.allmap
    let supzone = e.target.value
    if (supzone !== '0') {
      let mapzone = await mapfb.filter(function (el) {
        return el.supzone == supzone;
      });
      // mapfb.filter((el: any) => { el.DetailPlant.ZoneId == supzone})
      console.log('mapfb filter: ', mapzone)
      this.loadMapZone(mapzone)
    } else {
      this.loadMapZone(mapfb)
    }
  }

  // แสดงแผนที่แปลงอ้อยตามโซน
  loadMapZone(data: any) {

    this.cntFilterPlot = data.length
    let totalArea: number = data.reduce((accumulator, currentItem) => accumulator + currentItem.landvalue, 0);
    this.areaFilterPlot = totalArea
    let totalSugarcane: number = data.reduce((accumulator, currentItem) => accumulator + currentItem.assess, 0);
    this.canevalueFilterPlot = totalSugarcane
    
    let mapfb = data
    console.log('mapdata: ', mapfb)
    let upos = this.upos

    this.loader.load().then(() => {

      // 1. create map
      this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
        center: upos,
        zoom: 10,
        mapTypeId: 'roadmap',
      })

      const icon = {
        url: 'assets/images/bsflogo.png', // URL to the icon image
        scaledSize: new google.maps.Size(50, 50), // size in pixels
        origin: new google.maps.Point(0, 0), // origin of the image
        anchor: new google.maps.Point(25, 25) // anchor point of the image
      };

      // 2. Create marker
      let label: string = "<i class='fas fa-map-pin'></i> <span class='ggSriracha'> คุณอยู่ที่นี่ </span>"
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: upos,
        map: this.map,
        title: 'คุณอยู่ที่นี่',
        content: document.createElement('div'),
      });
      
      // Set custom icon for AdvancedMarkerElement
      const iconElement = document.createElement('img');
      iconElement.src = 'assets/images/bsflogo.png';
      iconElement.style.width = '50px';
      iconElement.style.height = '50px';
      marker.content = iconElement;

      // 3. Create circle
      const circle = new google.maps.Circle({
        center: upos,
        map: this.map,
        strokeWeight: 2,
        strokeColor: '#FF992C',
        fillColor: '#F5F8B4',
        fillOpacity: 0.35,
        radius: this.radius,  // รัศมีเป็นเมตร
      })

      // 4. polygon
      if (this.currentPolygon) {
        this.currentPolygon.setMap(null); // Remove the existing polygon from the map
      }

      for (let i = 0; i < mapfb.length; i++) {

        let fillColor = "#6A6A6A"
        let canetype = mapfb[i].canetype
        canetype = canetype.substring(1, 2)
        if (canetype !== undefined) {
          if (canetype == 'R') {
            fillColor = "#09FD0C"
          } else if (canetype == 'T') {
            fillColor = "#E9FD09"
          } else {
            fillColor = "#6A6A6A"
          }
        }

        const triangleCoords = mapfb[i].coordinates;
        this.currentPolygon = new google.maps.Polygon({
          paths: triangleCoords,
          strokeColor: '#FF5C3F',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: fillColor,
          fillOpacity: 0.35,
        });
        this.currentPolygon.setMap(this.map);

        this.currentPolygon.addListener('click', () => {
          console.log('landno :', mapfb[i].landno)
          if (this.mapsInfoWindow) {
            this.mapsInfoWindow.close();
          }

          let position = mapfb[i].coordinatesCenter
          let contentString = `
                      <div class="card bg-light d-flex flex-fill">
                        <div class="card-header text-muted border-bottom-0">
                          แปลง : ${mapfb[i].landno}
                        </div>
                        <div class="card-body pt-0">
                          <div class="row">
                            <div class="col-7">
                              <h2 class="lead"><b>${mapfb[i].fmname}</b></h2>
                              <!-- <h2 class="lead"><b>XXX</b></h2> -->
                              <p class="text-muted text-sm"><b>พื้นที่ : </b> ${Number(mapfb[i].landvalue)} </p>
                              <p class="text-muted text-sm"><b>ประเภท : </b> ${mapfb[i].canetype} </p>
                              <ul class="ml-4 mb-0 fa-ul text-muted">
                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-building"></i></span> Address: Demo Street 123, Demo City 04312, NJ</li>
                                <li class="small"><span class="fa-li"><i class="fas fa-lg fa-phone"></i></span> Phone #: + 800 - 12 12 23 52</li>
                              </ul>
                            </div>
                            <div class="col-5 text-center">
                              <img src="assets/images/bsfLogo.png" alt="fmbrr" class="img-circle img-fluid">
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <div class="text-right">
                            <a href="#" class="btn btn-sm bg-teal">
                              <i class="fas fa-comments"></i>
                            </a>
                            <a href="#" class="btn btn-sm btn-primary">
                              <i class="fas fa-user"></i> View Profile
                            </a>
                          </div>
                        </div>
                      </div>
                      `;

          this.mapsInfoWindow = new google.maps.InfoWindow({
            content: contentString,
            position: position,
            maxWidth: 400,
          })

          this.mapsInfoWindow.open(this.map);
        })

      }
    });

  }

  // แสดงแผนที่แปลงอ้อย
  loadMap1() {

    console.log('radius is: ',this.radius)

    // coordinates จาก sql
    // let mapfb = this.cpFmdata
    // console.log('mapfb is: ',mapfb)
    // console.log('coordinatescenter[0] is: ',mapfb[0].coordinatescenter)
    // let cpfm = this.cpFmdata
    let upos = this.upos

    this.loader.load().then(() => {

      // 1. create map
      this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
        center: upos,
        zoom: 10,
        mapTypeId: 'roadmap',
      })

      const icon = {
        url: 'assets/images/bsflogo.png', // URL to the icon image
        scaledSize: new google.maps.Size(50, 50), // size in pixels
        origin: new google.maps.Point(0, 0), // origin of the image
        anchor: new google.maps.Point(25, 25) // anchor point of the image
      };

      // 2. Create marker
      let label: string = "<i class='fas fa-map-pin'></i> <span class='ggSriracha'> คุณอยู่ที่นี่ </span>"
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position: upos,
        map: this.map,
        title: 'คุณอยู่ที่นี่',
        content: document.createElement('div'),
      });
      
      // Set custom icon for AdvancedMarkerElement
      const iconElement = document.createElement('img');
      iconElement.src = 'assets/images/bsflogo.png';
      iconElement.style.width = '50px';
      iconElement.style.height = '50px';
      marker.content = iconElement;

      // 3. Create circle
      const circle = new google.maps.Circle({
        center: upos,
        map: this.map,
        strokeWeight: 2,
        strokeColor: '#FF992C',
        fillColor: '#F5F8B4',
        fillOpacity: 0.35,
        radius: this.radius,  // รัศมีเป็นเมตร
      })

    });

  }  

  // ข้อมูลแปลงที่เลือก
  getDetailPlot(itid: string) {
    if (itid) {
      this.brdsql.getCpbyItid(itid).subscribe({
        next: (res: any) => {
          // console.log('res: ' ,res)
          if (res) {
            this.cpDetail = res.recordset[0]
            console.log('cpDetail :', this.cpDetail)
          }
        }, error(err) { }
        , complete: (() => { })
      })
      // this.cpDetail = this.mapFb.filter((e: any) => e.itid === itid)
      // console.log('cpDetail: ' ,this.cpDetail)
    }
  }

  togglePanel(): void {
    this.isHidden = !this.isHidden;
  }


  // +++++++++++++++ lz-string compress data ++++++++++++++++++++
  CHUNK_SIZE = 5000; // Define a reasonable chunk size

  compressData(data: any): string {
    const jsonString = JSON.stringify(data);
    return LZString.compress(jsonString);
  }
  
  decompressData(compressedString: string): any {
    const jsonString = LZString.decompress(compressedString);
    return JSON.parse(jsonString as string);
  }
  
  saveToLocalStorage(key: string, data: any): void {
    const compressedString = this.compressData(data);
    const numChunks = Math.ceil(compressedString.length / this.CHUNK_SIZE);
  
    for (let i = 0; i < numChunks; i++) {
      const chunk = compressedString.substring(i * this.CHUNK_SIZE, (i + 1) * this.CHUNK_SIZE);
      localStorage.setItem(`${key}_${i}`, chunk);
    }
    localStorage.setItem(`${key}_count`, numChunks.toString());
    // localStorage.setItem('testcompress', numChunks.toString());

  }
  
  loadFromLocalStorage(key: string): any {
    const numChunks = parseInt(localStorage.getItem(`${key}_count`) as string, 10);
    let compressedString = '';
  
    for (let i = 0; i < numChunks; i++) {
      const chunk = localStorage.getItem(`${key}_${i}`);
      compressedString += chunk;
    }
  
    return this.decompressData(compressedString);
  }
  
  removeFromLocalStorage(key: string): void {
    const numChunks = parseInt(localStorage.getItem(`${key}_count`) as string, 10);
  
    for (let i = 0; i < numChunks; i++) {
      localStorage.removeItem(`${key}_${i}`);
    }
    localStorage.removeItem(`${key}_count`);
  }  

  testX(data: any) {
    console.log('begin compress data...')
    
    // Save object to local storage
    this.saveToLocalStorage('testcompress', data);
    
    // Load object from local storage
    const loadedObject = this.loadFromLocalStorage('testcompress');
    console.log('Loaded object:', loadedObject);
    
    // Remove object from local storage
    // this.removeFromLocalStorage('testcompress');    
  }  
}
